import { z } from 'zod';
import { nullableList } from '../../zod-helpers';

const uuid = z.string().uuid();

export const reviewStateSchema = z.enum(['pending', 'published', 'rejected']);
export type ReviewState = z.infer<typeof reviewStateSchema>;

export const productReviewSchema = z.object({
  id: uuid,
  product_id: uuid,
  product_name: z.string().nullable().optional(),
  reviewer_id: uuid.nullable().optional(),
  reviewer_handle_masked: z.string().nullable().optional(),
  rating: z.number().int().min(1).max(5),
  body: z.string().nullable().optional(),
  state: reviewStateSchema,
  created_at: z.string().nullable().optional(),
});
export type ProductReview = z.infer<typeof productReviewSchema>;
export const productReviewListSchema = nullableList(productReviewSchema);

export const reviewListFiltersSchema = z.object({
  state: reviewStateSchema.optional(),
  limit: z.number().int().min(1).max(200).optional(),
});
export type ReviewListFilters = z.infer<typeof reviewListFiltersSchema>;

export const reviewModerateBodySchema = z
  .object({
    state: z.enum(['published', 'rejected']),
    reason: z.string().max(500).optional(),
  })
  .superRefine((val, ctx) => {
    if (val.state === 'rejected' && (!val.reason || val.reason.trim().length === 0)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['reason'],
        message: 'A reason is required when rejecting a review.',
      });
    }
  });
export type ReviewModerateBody = z.infer<typeof reviewModerateBodySchema>;
